import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { Button, Tooltip } from "@mui/material";

export const getCoachingColumns = (
  primaryDark,
  handleOpenUserForm,
  handleNavigateToUserFeed
) => [
  { field: "name", headerName: "Name", flex: 2 },
  { field: "school", headerName: "School", flex: 2 },
  { field: "division", headerName: "Department", flex: 2 },
  {
    field: "assessmentsCount",
    headerName: "Number of Lessons Visited",
    headerAlign: "center",
    flex: 1,
    type: "number",
    align: "center",
    filterable: false,
  },
  {
    field: "areaOfStrengthCount",
    headerName: "Area of Strength Count",
    headerAlign: "center",
    flex: 1,
    type: "number",
    align: "center",
    filterable: false,
    hide: true,
  },
  {
    field: "areaOfDevelopmentCount",
    headerName: "Area of Development Count",
    headerAlign: "center",
    flex: 1,
    type: "number",
    align: "center",
    filterable: false,
    hide: true,
  },
  {
    field: "difference",
    headerName: "RPF",
    headerAlign: "center",
    flex: 1,
    type: "number",
    align: "center",
    filterable: false,
  },
  {
    field: "linkedStatus",
    headerName: "Linked",
    headerAlign: "center",
    align: "center",
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: (params) =>
      params.row.linked ? (
        <Tooltip title="Linked to a user, view their coaching feed">
          <Button
            onClick={() => handleNavigateToUserFeed(params.row.id)}
            style={{ backgroundColor: "transparent", border: "none" }}
            disableElevation
            disableRipple
          >
            <LinkIcon style={{ color: primaryDark }} />
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title="Not linked – click to link this user">
          <Button
            onClick={() => handleOpenUserForm(params.row)}
            style={{ backgroundColor: "transparent", border: "none" }}
            disableElevation
            disableRipple
          >
            <LinkOffIcon style={{ color: "red" }} />
          </Button>
        </Tooltip>
      ),
  },
];
